import React from "react";
import Offline from "../component/Offline";

// Lazy load your components here
const Home = React.memo(React.lazy(() => import('../component/Home')));
const Login = React.lazy(() => import('../component/Login'));
const Register = React.lazy(() => import('../component/Register'));
const CoinAcceptor = React.lazy(() => import('../component/CoinAcceptor'));
const Dashboard = React.lazy(() => import('../component/Dashboard'));
const NotFound = React.lazy(() => import('../component/NotFound'));
const NotAuthorized = React.lazy(() => import('../component/NotAuthorized'));
const NoMacAddress = React.lazy(() => import('../component/NoMacAddress'));
const MachineGroupLogs = React.lazy(() => import('../component/MachineGroupLogs'));
const LoginMachine = React.lazy(() => import('../component/LoginMachine'));
const NoServiceAvailable = React.lazy(() => import('../component/NoServiceAvailable'));

export interface AppRoute {
  path: string;
  element: React.ReactNode;
  guard?: boolean;
  socket?: { status: boolean, url?: string, path?: string };
}

export const getAppRoutes = (): AppRoute[] => [
  {
    path: "/",
    element: <Home />,
    guard: true
  },
  {
    path: "/coinaceptor",
    element: <CoinAcceptor />,
    guard: false,
    socket: { status: true, url: `${process.env.REACT_APP_API_URL || "http://localhost:4000"}/user`, path: "/pesowifi-socket" }
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    guard: true
  },
  {
    path: "/login",
    element: <Login />
  },
  {
    path: "/register",
    element: <Register />
  },
  {
    path: "/notauthorized",
    element: <NotAuthorized />,
  },
  {
    path: "/nomacaddress",
    element: <NoMacAddress />
  },
  {
    path: "/offline",
    element: <Offline />
  },
  {
    path: "/machinegrouplogs",
    element: <MachineGroupLogs />,
    socket: { status: true, url: `${process.env.REACT_APP_API_URL || "http://localhost:4000"}/machine`, path: "/pesowifi-socket" }
  },
  {
    path: "/loginmachine",
    element: <LoginMachine />
  },
  {
    path: "/noserviceavailable",
    element: <NoServiceAvailable />
  },
  
  {
    path: "*",
    element: <NotFound />,
  }
];